import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../custom/classes/event';
import { ICalendarState, IMonth, CalendarViewMode, CalendarDeviceMode } from '../classes/calendar';
import { ICalendarAppText } from '../custom/classes/calendar-text';

import { connect } from 'react-redux';

import { ICalendarAppState } from '../redux-state';

import CalendarViewToggleView from 'calendar-view-toggle.view';
import { setToGrid, setToList } from '../redux-state/actions/calendar-settings.actions';

interface ICalendarViewTogglePropsExternalProps {

}

interface StateToProps {
    text: ICalendarAppText
    calendarMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
}

interface DispatchToProps {
    setToGrid: () => void;
    setToList: () => void;
}

export type CalendarViewToggleProps = ICalendarViewTogglePropsExternalProps & StateToProps & DispatchToProps;

export class CalendarViewToggleBase extends React.Component<CalendarViewToggleProps, any> {
    render() {
        return (
            <>
                {
                    this.props.calendarDeviceMode === CalendarDeviceMode.DESKTOP ? <CalendarViewToggleView {...this.props} /> : null
                }
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ICalendarViewTogglePropsExternalProps): StateToProps {
    return {
        text: state.calendarText,
        calendarMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToGrid: () => dispatch(setToGrid()),
        setToList: () => dispatch(setToList())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(CalendarViewToggleBase);